import React, { useState, useRef, useLayoutEffect, useEffect } from 'react'
import "./Home.css"
import logo from "../../Images/logo1.png"
import Navbars from "../Navbars/Navbars"
import About from "../About/About"
import Fotter from "../Fotter/Fotter"
import Roadmap from "../Roadmap/Roadmap"
import Faq from '../Faq/Faq'
import Mints from '../Mint/Mints'
import { arrayExpression } from '@babel/types'
import { useHistory } from 'react-router'
function Home() {
    const [bottomMargin, setBottomMargin] = useState(100);
    const [minMargin, setMinMargin] = useState(0);
    const [maxMargin, setMaxMargin] = useState(0);
    const prevScroll = useRef(0);
    const parent = useRef(0);
    const [active, setActive] = useState("homes");
    const history = useHistory();
    const about = document.querySelector("#about");
    const mints = document.querySelector("#mints");
    const road = document.querySelector("#road");
    const faq = document.querySelector("#faq");



    const handleScroll = () => {
        console.log(window.innerWidth)
        console.log(parent.current.scrollTop)
        if (prevScroll.current < parent.current.scrollTop && bottomMargin < maxMargin) {
            setBottomMargin(bottomMargin + 23)
            if (bottomMargin > maxMargin) {
                bottomMargin(maxMargin)
            }

        }
        else if (prevScroll.current > parent.current.scrollTop && bottomMargin > minMargin && parent.current.scrollTop < 510) {
            setBottomMargin(bottomMargin - 10)
            if (bottomMargin < minMargin || parent.current.scrollTop === 0) {
                setBottomMargin(minMargin)
            }
        }
        prevScroll.current = parent.current.scrollTop
    }
    useEffect(() => {
        if (window.innerWidth > 1400) {
            setMinMargin(0)
            setMaxMargin(400)
            setBottomMargin(0)
        }
        else if (window.innerWidth > 1024) {
            setMinMargin(100)
            setMaxMargin(400)
            setBottomMargin(100)
        }
        else {
            setMinMargin(120)
            setMaxMargin(450)
            setBottomMargin(120)
        }
        const io = new IntersectionObserver(entries => {

            entries.forEach(entry => {

                // Add 'active' class if observation target is inside viewport
                if (entry.intersectionRatio > 0) {
                    console.log(entry.target.id)
                    setActive(entry.target.id)
                }


            })
        })

        io.observe(document.querySelector("#homes"))
        io.observe(document.querySelector("#about"))
        io.observe(document.querySelector("#mints"))
        io.observe(document.querySelector("#road"))
        io.observe(document.querySelector("#faq"))

    }, [window.innerWidth])
    useEffect(() => {
        if (history.location.hash === "#about") {
            setActive("about")
        }
        else if (history.location.hash === "#mints") {
            setActive("mints")
        }
        else if (history.location.hash === "#faq") {
            setActive("faq")
        }
        else if (history.location.hash === "#road") {
            setActive("road")
        }
    }, [history.location.hash])



    return (
        <>

            <div className="home__wrapper" ref={parent} onScroll={() => { handleScroll() }}>
                <Navbars active={active} />
                <div className="home_img" id="homes" >
                    <div className="home_main" >
                        <img src={logo} className="home_iner_img" style={{ transform: `translateY(${bottomMargin}px)` }} />
                        {/* <img src={logo} className="home_iner_img" style={{ transform: `translateY(${bottomMargin}px)`, position: "absolute" }} /> */}

                    </div>

                </div>


                <About />
                <Mints />
                <Roadmap />
                <Faq />
                <Fotter />

            </div>
        </>
    )
}

export default Home
